import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app.reducer';
import { ConfirmationService } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as actions from 'redux/actions';
import { eq } from 'lodash';
import { CategoryResponse } from 'app/models';
import { Listbox } from 'primeng/listbox';
import { ToastNotificationService } from 'app/components';

@Component({
  selector: 'app-outlet-manager',
  template: `
    <p-dialog
      [dismissableMask]="true"
      [(visible)]="showModal"
      [style]="{ width: '60vw' }"
      [modal]="true"
      position="center"
      (onHide)="closeModalDialog()"
    >
      <ng-template pTemplate="header">
        <h4>{{ title }}</h4>
      </ng-template>
      <div class="p-mt-3">
        <form [formGroup]="form">
          <div class="p-d-flex p-jc-center">
            <div class="p-col">
              <div class="p-fluid">
                <div class="p-field">
                  <label>Name*</label>
                  <input
                    id="name"
                    formControlName="name"
                    inputId="name"
                    type="text"
                    aria-describedby="name-help"
                    [class]="
                      invalidField('name')
                        ? 'details-input ng-invalid ng-dirty'
                        : 'details-input'
                    "
                    pInputText
                  />
                  <small
                    *ngIf="invalidField('name')"
                    id="name-help"
                    class="p-error"
                    >Name is a required field.</small
                  >
                </div>
                <div
                  class="p-d-flex p-jc-between p-ai-center"
                  *ngIf="categorySelected"
                >
                  <span><b>Category:</b> {{ categorySelected.name }}</span>
                  <i
                    *ngIf="categorySelected?.id"
                    class="pi pi-times-circle category-clear-icon"
                    title="Clear category"
                    (click)="clearCategory()"
                  ></i>
                </div>
                <div class="p-field" *ngIf="categoriesWithNoLabel">
                  <!--                  <label>Select a category</label>-->
                  <div class="p-mt-2"></div>
                  <p-listbox
                    #myListbox
                    (onClick)="selectItemOnClick()"
                    [filter]="true"
                    [options]="categoriesWithNoLabel"
                    formControlName="category"
                    optionLabel="name"
                    filterPlaceHolder="Select a category"
                    [listStyle]="{
                      height: '180px',
                      'max-height': '180px',
                      'max-with': '100%'
                    }"
                    emptyMessage="Loading categories.."
                  ></p-listbox>
                  <small
                    *ngIf="invalidField('category')"
                    id="company-help"
                    class="p-error"
                    >Category is a required option.</small
                  >
                  <div class="p-d-flex p-jc-between p-mt-2">
                    <div>
                      <button
                        pButton
                        icon="pi pi-cog"
                        type="button"
                        class="p-button-sm"
                        label="Manage Categories"
                        (click)="openCategoryManagerModal()"
                      ></button>
                    </div>
                  </div>
                </div>
                <!-- <div class="p-d-flex p-jc-between">
                  <div></div>
                  <div *ngIf="outletSelected">
                    <p-button
                      pRipple
                      icon="pi pi-star"
                      (click)="handleDelete()"
                      label="Unfollow"
                      styleClass="p-button-raised p-button-danger p-button-text"
                    ></p-button>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </form>
      </div>

      <ng-template pTemplate="footer">
        <div class="p-mt-3"></div>
        <p-button
          pRipple
          icon="pi pi-times"
          (click)="closeModalDialog()"
          label="Cancel"
          styleClass="p-button-raised p-button-secondary p-button-text"
        ></p-button>
        <p-button
          [disabled]="isSaving"
          pRipple
          icon="pi pi-check"
          (click)="handleSubmit()"
          label="Save"
          styleClass="p-button-primary"
        >
        </p-button>
      </ng-template>
    </p-dialog>
  `,
  styles: [
    `
      :host ::ng-deep .p-dialog .p-dialog-header {
        border-bottom: 1px solid #dee2e6;
      }

      :host ::ng-deep .p-dialog .p-dialog-footer {
        border-top: 1px solid #dee2e6;
      }

      :host ::ng-deep .p-dialog .p-dialog-content {
        padding-top: 10px;
      }

      :host ::ng-deep {
        .p-button:focus {
          box-shadow: none;
        }

        .p-inputtext:focus {
          box-shadow: none;
        }

        .p-button {
          background: #465675;
          border-color: transparent;
        }

        .p-button:hover {
          background: #4e5f80;
          border-color: #4e5f80;
        }

        .category-clear-icon {
          cursor: pointer;
          color: #465675;
        }
      }
    `,
  ],
})
export class OutletManagerComponent implements OnInit {
  public form: FormGroup;
  public categories: CategoryResponse[];
  public categoriesWithNoLabel: CategoryResponse[];
  public noLabelOption: CategoryResponse;
  public title: string;
  public showModal: boolean;
  public isSaving: boolean;
  public outletSelected: any;
  public project: any;
  public userProject: any;
  public categorySelected: any;

  @ViewChild('myListbox') myListboxComponent: Listbox;

  constructor(
    private store: Store<AppState>,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private notificationService: ToastNotificationService
  ) {
    this.title = 'New Outlet';
    this.isSaving = false;
    this.categories = [];
    this.noLabelOption = new CategoryResponse({ id: null, name: '(none)' });
    this.categoriesWithNoLabel = [this.noLabelOption];
    this.categorySelected = this.noLabelOption;
  }

  ngOnInit() {
    this.store.select('category').subscribe(({ categories }) => {
      this.categories = categories;
      this.categoriesWithNoLabel = categories
        ? [this.noLabelOption, ...categories]
        : [this.noLabelOption];
    });

    this.form = this.formBuilder.group({
      id: [null],
      name: [{ value: null, disabled: true }],
      category: [
        {
          value: null,
        }
      ],
    });
    this.store
      .select('outletManager')
      .subscribe(
        ({
          loading,
          error,
          message,
          creationMode,
          successResponse,
          editionMode,
          showOutletManager,
          outlet,
        }) => {
          this.isSaving = loading;
          this.showModal = showOutletManager;
          this.title = outlet ? 'Edit Outlet' : 'New Outlet';

          if (showOutletManager) {
            if (this.myListboxComponent._filterValue) {
              this.myListboxComponent._filterValue = null;
              this.myListboxComponent._filteredOptions = this.categories;
            }
          }

          // Store to Create/Edit/delete outlet
          if (successResponse) {
            this.notificationService.showMessage(message, 'Success');
          } else if (error) {
            this.notificationService.showMessage('Error Outlet manager.', 'Error');
          }

          if (editionMode) {
            this.categorySelected =
              this.categories.find((item) => eq(item.id, outlet?.categoryId)) ||
              this.noLabelOption;
            this.outletSelected = outlet;
            this.form.get('id').setValue(outlet.id);
            this.form.get('name').setValue(outlet.name);
            this.form.get('category').setValue(this.categorySelected);
          }

          if (creationMode) {
            this.categorySelected = this.noLabelOption;
            this.outletSelected = null;
            this.form.get('id').setValue(null);
            this.form.get('name').setValue('');
            this.form.get('category').setValue(this.noLabelOption);
          }
        }
      );
    this.store.select('project').subscribe(({ projectSelected }) => {
      if (projectSelected) {
        this.userProject = projectSelected;
      }
    });
  }

  selectItemOnClick() {
    this.categorySelected = this.form.get('category').value;
  }

  clearCategory() {
    this.categorySelected = this.noLabelOption;
    this.form.get('category').setValue(this.noLabelOption);
  }

  closeModalDialog() {
    this.form.reset();
    this.store.dispatch(actions.hideOutletManagerDialog());
  }

  invalidField(field: string) {
    return (
      this.form.controls[field].errors && this.form.controls[field].touched
    );
  }

  handleSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    if (this.outletSelected) {
      this.editOutlet();
    } else {
      this.createOutlet();
    }
  }

  onClose() {
    this.store.dispatch(actions.resetOutletManagerState());
  }

  handleDelete() {
    this.confirmationService.confirm({
      message: 'Are you sure?',
      header: 'Delete Confirmation',
      icon: 'pi pi-exclamation-triangle',
      key: 'deleteOutlet',
      accept: () => {
        this.deleteOutlet();
      },
      reject: (type) => {
        // handle rejected option ConfirmEventType.CANCEL
      },
    });
  }

  createOutlet() {
    this.isSaving = true;
    const payload: any = {
      userProject: this.userProject,
      name: this.form.get('name').value,
    };
    if (this.categorySelected?.id) {
      payload.categoryId = this.categorySelected.id;
    }
    this.store.dispatch(actions.createOutlet({ payload }));
  }

  editOutlet() {
    this.isSaving = true;
    const payload = {
      id: this.outletSelected.id,
      partyId: this.outletSelected.partyId,
      userProject: this.userProject,
      name: this.form.get('name').value,
      userLabelId: this.categorySelected.id,
    };
    this.store.dispatch(actions.updateOutlet({ payload }));
  }

  deleteOutlet() {}

  openCategoryManagerModal() {
    this.store.dispatch(actions.showCategoriesListDialog());
  }
}
